import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="text-xl font-bold bg-gradient-to-r from-yellow-500 to-yellow-600 bg-clip-text text-transparent mb-4">
              THE 21-DAY BUSINESS WEBSITE™
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Votre site business complet, créé en 3 semaines. Design sur mesure, stratégie et contenu optimisé pour la conversion.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Navigation</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-slate-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">Accueil</Link></li>
              <li><Link to="/processus" className="text-slate-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">3 semaines</Link></li>
              <li><Link to="/accelerateur" className="text-slate-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">Accélérateur</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Ressources</h4>
            <ul className="space-y-2">
              <li><Link to="/portfolio" className="text-slate-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">Portfolio</Link></li>
              <li><Link to="/a-propos" className="text-slate-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">À propos</Link></li>
              <li><Link to="/contact" className="text-slate-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Contact</h4>
            <Link 
              to="/contact" 
              className="inline-flex items-center justify-center whitespace-nowrap cursor-pointer font-medium transition-all duration-300 bg-yellow-600 text-white hover:bg-yellow-700 px-6 py-3 rounded-lg text-sm w-full"
            >
              Contactez-nous
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-slate-400 text-sm">
            © {currentYear} THE 21-DAY BUSINESS WEBSITE™. Tous droits réservés.
          </p>
          <div className="flex items-center space-x-6">
            <Link to="/mentions-legales" className="text-slate-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
              Mentions légales
            </Link>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-yellow-500 transition-colors text-sm cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
